<template>
  <div class="calendar-box c-with-box-shadow">
    <div class="calendar-header">
      <slot name="header" />
    </div>

    <div class="calendar">
      <slot name="calendar" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.calendar-box {
  padding: 24px;
  background-color: white;
  border-radius: 12px;
}

.calendar-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 16px;
  height: 48px;

  z-index: 1;
  pointer-events: none;

  &:empty {
    height: 32px;
  }

  > * {
    pointer-events: auto;
  }
}

.calendar {
  margin-top: -64px;
}
</style>
